import { c as _c } from "react/compiler-runtime";
import { useNamedInjection } from '@/hooks/use-named-injection';
import { curveSmootherRequirementsSymbol, type CurveSmootherRequirements } from '@/lib/geometry/curve-smoother/curve-smoother.requirements';
import { SmoothStrategy } from '@/lib/geometry/curve-smoother/smooth-strategy.enum';
import { useCallback } from 'react';
import type { KeyboardLike, KeyWith } from '@/lib/piano/keyboard';
export const useInterpolatedSerieCubicSpline = keyboard => {
  const $ = _c(8);
  const cubicSplineSmoother = useNamedInjection(curveSmootherRequirementsSymbol, SmoothStrategy.CubicSpline);
  let t0;
  if ($[0] !== keyboard.size) {
    t0 = keypoints => new Map(keypoints.entries().map(t1 => {
      const [index, keypoint] = t1;
      const interpolatedIndex = 1 + Math.round((index - 1) * (keyboard.size - 1) / 87);
      return [interpolatedIndex, keypoint];
    }));
    $[0] = keyboard.size;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const interpolateStandardKeypointsToKeyboardSize = t0;
  let t1;
  if ($[2] !== cubicSplineSmoother || $[3] !== keyboard) {
    t1 = keypoints_0 => {
      const keyPointsInputData = keyboard.mapToArray(key => keypoints_0.get(key.number));
      const interpolatedSerie = cubicSplineSmoother.smoothCurve(keyPointsInputData, undefined);
      return interpolatedSerie;
    };
    $[2] = cubicSplineSmoother;
    $[3] = keyboard;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const generateCubicInterpolatedKeyboardSerie = t1;
  let t2;
  if ($[5] !== generateCubicInterpolatedKeyboardSerie || $[6] !== interpolateStandardKeypointsToKeyboardSize) {
    t2 = {
      generateCubicInterpolatedKeyboardSerie,
      interpolateStandardKeypointsToKeyboardSize
    };
    $[5] = generateCubicInterpolatedKeyboardSerie;
    $[6] = interpolateStandardKeypointsToKeyboardSize;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};